import { render, staticRenderFns } from "./InquietudesAntisoborno.vue?vue&type=template&id=4dcca4a1&"
import script from "./InquietudesAntisoborno.vue?vue&type=script&lang=js&"
export * from "./InquietudesAntisoborno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports